import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { contentLoadingChange } from "../../../../Reducer/componentSlice";
import Handler from "../../../../Helpers/Handler";

const ThirdDocument = ({ associateDetails, onVerified }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [pan, setPan] = useState("");

    const panSubmit = async () => {
        if (!pan) return toast.error("Enter Pan No.");
        setLoading(true);
        dispatch(contentLoadingChange(true));
        const response = await Handler({ method: "patch", url: `/admin/client/associate/kyc/pan/${associateDetails?.associateId}`, data: { panNo: pan?.toUpperCase() } });
        dispatch(contentLoadingChange(false));
        if (response?.success) {
            toast.success(response?.data?.message || "Pan Number submitted successfully");
            setTimeout(() => { setLoading(false); onVerified?.(); }, 1200);
        } else {
            setLoading(false);
            toast.error(response?.data?.message || "Submission failed");
        }
    };

    useEffect(() => { setPan(""); }, [associateDetails]);

    return (
        <React.Fragment>
            <div className="mb-3">
                <label className="form-label">Pan No</label>
                <input type="text" className="form-control" autoComplete="off" disabled={loading} value={pan || ""} onChange={(e) => setPan(e.target.value.toUpperCase())} placeholder="Enter Pan Number" />
            </div>
            <div className="mb-3 text-center">
                <button className="btn btn-primary" onClick={panSubmit} disabled={loading}>{loading ? "Submitting..." : "Submit"}</button>
            </div>
        </React.Fragment>
    );
};

export default ThirdDocument;
